import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import IconButton from "./IconButton";
import { createMarkup } from "../Helpers/htmlHelper";

import Vacancy_Backdrop from "../../assets/images/careers_backdrop.webp";

import "../../css/Components/VacanciesSwiper.scss";

const VacanciesSwiper = ({ onDataLoad }) => {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch("https://ame.recruitee.com/api/offers", {
          method: "GET",
          credentials: "omit",
        });
        const data = await response.json();
        if (data.offers && Array.isArray(data.offers)) {
          const sortedOffers = data.offers
            .map((offer) => {
              // Dynamically update sharing_description if it seems incomplete
              if (offer.sharing_description) {
                const lastPeriod = offer.sharing_description.lastIndexOf(".");
                const lastQuestionMark = offer.sharing_description.lastIndexOf("?");
                const lastExclamationMark = offer.sharing_description.lastIndexOf("!");
                const lastPunctuation = Math.max(lastPeriod, lastQuestionMark, lastExclamationMark);

                // If no proper ending punctuation is found or it's not at the end, trim to the last found punctuation + 1
                if (lastPunctuation !== -1 && lastPunctuation !== offer.sharing_description.length - 1) {
                  offer.sharing_description = offer.sharing_description.substring(0, lastPunctuation + 1);
                }
              }
              return offer;
            })
            .sort((a, b) => {
              const dateA = new Date(a.published_at);
              const dateB = new Date(b.published_at);
              return dateB - dateA;
            });

          setJobs(sortedOffers);
        } else {
          setJobs([]); // Handle the case where data.offers is not an array
        }
      } catch (error) {
        console.error("Failed to fetch jobs:", error);
        setJobs([]); // Handle the error by setting jobs to an empty array
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    if (jobs.length > 0) {
      new Swiper(".vacancies-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 4,
          },
        },
        loop: true,
        grabCursor: true,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slideToClickedSlide: true,
        autoplay: {
          delay: 15000,
          disableOnInteraction: true,
        },
      });
    }

    if (onDataLoad) {
      onDataLoad();
    }
  }, [jobs, onDataLoad]);

  return (
    <div className="swiper vacancies-swiper pb-mts_1_5 pb-md-mts_4_5">
      <div className="swiper-wrapper py-mts_2">
        {[...jobs].map((job, index) => (
          <div key={index} className="swiper-slide" style={{ "--image-url": `url(${job.cover_image?.url || Vacancy_Backdrop})` }}>
            <div className={`text-primary-dark-blue py-mts_1_75 px-4 rounded-mts_1_875 d-flex flex-column`}>
              <h3 className="d-md-none" dangerouslySetInnerHTML={createMarkup(job.title)}></h3>
              <h2 className="d-none d-md-block" dangerouslySetInnerHTML={createMarkup(job.title)}></h2>
              <p className="vacancy-content" dangerouslySetInnerHTML={createMarkup(job.sharing_description)}></p>

              <Row className="mt-auto">
                <Link to={job.careers_url} target="_blank" className="float-end">
                  <IconButton variant="link" iconAfter="arrow-right" size="sm">
                    {t("home_careers_CTA")}
                  </IconButton>
                </Link>
              </Row>
            </div>
          </div>
        ))}

        <div key={"view-all"} className="swiper-slide" style={{ "--image-url": `url(${Vacancy_Backdrop})` }}>
          <div className={`text-primary-dark-blue py-mts_1_75 px-4 rounded-mts_1_875 d-flex w-100 flex-column`}>
            <Row className="my-auto">
              <Link to={"https://career.ame.nu"} target="_blank" className="">
                <IconButton variant="link" iconAfter="arrow-right" size="lg">
                  {t("home_careers_vacanciesSwiper_CTA")}
                </IconButton>
              </Link>
            </Row>
          </div>
        </div>
      </div>
      <div className="swiper-button-next"></div>
      <div className="swiper-button-prev"></div>
    </div>
  );
};

export default VacanciesSwiper;
